import React from "react";
import { MainLayout } from "../../layouts";
import { Tabs } from "antd";
import {
  HeartOutlined,
  ClockCircleOutlined,
  CloudServerOutlined,
  PushpinOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { ResponsiveContainer, SuccessButton } from "../../components";
import TabContentSection from "./TabContentSection";
import TabTitle from "./TabTitle";
import ImagesList from "./ImagesList";
import { useMediaQuery } from "react-responsive";

const Gallery: React.FC = (props) => {
  const isSm = useMediaQuery({ query: "(max-width: 640px)" });
  return (
    <MainLayout fixed={true} className="bg-or_gray-100">
      <ResponsiveContainer>
        <Tabs
          defaultActiveKey="memories"
          size="large"
          tabPosition={isSm ? "top" : "left"}
          className="bg-white"
        >
          <Tabs.TabPane
            tab={<TabTitle icon={<PushpinOutlined />}>My Memories</TabTitle>}
            key="memories"
          >
            <ImagesList />
            <TabContentSection
              title="My Documents"
              button={
                <SuccessButton
                  icon={<PlusOutlined />}
                  className="rounded-md flex items-center"
                >
                  Add
                </SuccessButton>
              }
            ></TabContentSection>
            <TabContentSection
              title="My Audios"
              button={
                <SuccessButton
                  icon={<PlusOutlined />}
                  className="rounded-md flex items-center"
                >
                  Add
                </SuccessButton>
              }
            ></TabContentSection>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <TabTitle icon={<CloudServerOutlined />}>My Archives</TabTitle>
            }
            key="archives"
          >
            Content of Tab Pane 2
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <TabTitle icon={<ClockCircleOutlined />}>
                Recently Deleted
              </TabTitle>
            }
            key="deleted"
          >
            Content of Tab Pane 3
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={<TabTitle icon={<HeartOutlined />}>Most Likable</TabTitle>}
            key="likable"
          >
            Content of Tab Pane 3
          </Tabs.TabPane>
        </Tabs>
      </ResponsiveContainer>
    </MainLayout>
  );
};

export default Gallery;
